import React from 'react'
import styled from 'styled-components'
import { StakePosition, UserStakePosition } from './StakePosition'
import { Colors, Fonts, FontWeights } from '../../../constants'

interface Props {
  positions: UserStakePosition[]
}

export function StakePositions({ positions }: Props) {
  return (
    <Container>
      <Header>
        <label>Positions</label>
        <label>Claimable</label>
      </Header>
      {positions.length > 0 ? (
        positions.map((position, index) => <StakePosition key={index} position={position} />)
      ) : (
        <NoClaimable>You have no staked positions</NoClaimable>
      )}
    </Container>
  )
}

const Container = styled.div``

const Header = styled.div`
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  font-family: ${Fonts.Body};
  font-weight: ${FontWeights.Light};
  border-bottom: 1px solid ${Colors.DarkerGray};
  text-transform: uppercase;
  text-decoration: none;
`

const NoClaimable = styled.div`
  padding: 15px 0 0 0;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  font-family: ${Fonts.Body};
  font-weight: ${FontWeights.Regular};
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
`
